import { useQuery } from '@tanstack/react-query'
import { LocationEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetLocations(): {
  locations: LocationEntity[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: locations,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(['locations'], async () => {
    return qoursesApi.location.locationControllerGetLocationsV1()
  })

  let isEmpty = true

  if (locations === undefined) {
    return { locations: [], isLoading, isEmpty, isError, refetch, isRefetching }
  }

  if (locations.length > 0) {
    isEmpty = false
  }

  return { locations, isLoading, isEmpty, isError, refetch, isRefetching }
}
